import React from 'react';
import { hideModal } from '../redux/features/oxygen/customModalSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { updateCustomerOnboardingStat } from '../services/PrequalificationService';

const ConfirmOxygenDetailsUpdate = ({data}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const storePrecustomer = useSelector((state) => state?.precustomer?.precustomerData);
    
    const handleProceed = async () => {
        // Make api call to update the onboarding status
        await updateCustomerOnboardingStat(storePrecustomer.precustomer?.msisdn, "NEWENTRY");
        dispatch(hideModal())
        // Redirect fill the update form.
        navigate("/oxygendetails-update");
    }

  return (
    <div className="card">
        <div className="card-header">
        <h3 className="mb-0 card-title text-info">
            Kindly Confirm
        </h3>
        </div>
        <div className="card-body">
        <div className="row">
            <div className="col-md-12 mb-4">
            <div className="d-flex flex-column align-items-start my-2">
                <div className='mb-2' style={{ fontSize: "18px", color: "black" }}>
                    {data?.message ? `${data?.message} , Would you like to retry with a different detail ? ` : "Would you like to retry with a different detail ?"}  
                </div>
            </div>
            </div>

        <div className="col-md-12">
            <div className="form-group d-flex justify-content-center align-items-center gap-5">
                <button className="btn btn-secondary" onClick={() => dispatch(hideModal())}>
                    <b>NO</b>
                </button>
                <button className="btn btn-primary" onClick={handleProceed}>
                    <b>YES</b>
                </button>
            </div>
        </div>

        </div>
        </div>
    </div>
  )
}

export default ConfirmOxygenDetailsUpdate;